export const PATTERSON_FUSE_PMS = 'pattersonfuse';
export const EAGLESOFT_PMS = 'Eaglesoft 18';
